import {
  EProductVariantVisibility,
  ProductsListItem,
  ProductsSelector
} from "modules/products";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { PackSlotOptionFormValue } from "../../../packs.types";

interface PackVariantsPickerModalProps {
  isOpen: boolean;
  onClose: () => void;
  value: PackSlotOptionFormValue[];
  onChange: (value: PackSlotOptionFormValue[]) => void;
  title?: string;
}

const filterPackEligible = (item: ProductsListItem) =>
  item.visibility !== EProductVariantVisibility.Hidden;

export const PackVariantsPickerModal = ({
  isOpen,
  onClose,
  value,
  onChange,
  title
}: PackVariantsPickerModalProps) => {
  const { t } = useTranslation();

  const [products, setProducts] = useState<ProductsListItem[]>([]);

  useEffect(() => {
    if (!isOpen) return;
    const seeded = value.map((option) => ({
      id: option.productVariantId,
      name: option.productVariantName,
      image: option.productVariantImage,
      categoryName: option.productCategoryName,
      colorAttributeValue: option.productColorValue
        ? { value: option.productColorValue }
        : undefined
    })) as unknown as ProductsListItem[];
    setProducts(seeded);
  }, [isOpen]);

  const handleChange = (next: ProductsListItem[]) => {
    setProducts(next);
    onChange(
      next.map((item, index) => ({
        productVariantId: item.id,
        productVariantName: item.name,
        productVariantImage: item.image ?? null,
        productCategoryName: item.categoryName,
        productColorValue: item.colorAttributeValue?.value,
        position: index
      }))
    );
  };

  return (
    <ProductsSelector
      isOpen={isOpen}
      onClose={onClose}
      title={title ?? t("Select Pack Options")}
      value={products}
      onChange={handleChange}
      filterFn={filterPackEligible}
    />
  );
};
